import { Box, Input, InputGroup, InputLeftElement, Text } from '@chakra-ui/react';
import React, { useState, useCallback } from 'react';
import CoveySymbol from '../assets/Icons/coveySymbol';
import { SearchIcon } from '@chakra-ui/icons';
import List from './List';
import { useAppStore, AppStoreState } from '../store';
import ProjectInfoMain from './projectInfo/ProjectInfoMain';
import { getProjectList } from '../api/InvestorSearch/search';
import MobileMenu from './mobileComponents/MobileMenu';

export default function Content() {
  const showProjectDetails = useAppStore((state: AppStoreState) => state.showProjectDetails);
  const renderSearchResults = useAppStore((state: AppStoreState) => state.renderSearchResults);
  const setLoading = useAppStore((state: AppStoreState) => state.setLoading);
  const setSearchResults = useAppStore((state: AppStoreState) => state.setSearchResults);
  const setRenderSearchResults = useAppStore((state: AppStoreState) => state.setRenderSearchResults);
  const setSearchQuery = useAppStore((state: AppStoreState) => state.setSearchQuery);

  const [inputText, setInputText] = useState('');

  const debounce = <T extends (...args: any[]) => any>(func: T, delay: number): ((...args: Parameters<T>) => void) => {
    let timeoutId: NodeJS.Timeout;
    return (...args: Parameters<T>) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const fetchSearchResults = async (searchQuery: string, page = 1) => {
    setSearchQuery(searchQuery);
    try {
      const res = await getProjectList(searchQuery, page);
      if (res) {
        setSearchResults(res as any);
        setLoading(false);
      }
    } catch (err) {
      console.log('Error While Fetch All Users ', err);
    }
  };

  const debouncedFetchSearchResults = useCallback(debounce(fetchSearchResults, 3000), []);

  // Input handler
  const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRenderSearchResults(false);
    const inputValue = e.target.value;
    if (inputValue === '') {
      setRenderSearchResults(false);
    }
    const lowerCase = inputValue.toLowerCase();
    setInputText(lowerCase);
    lowerCase !== '' && setLoading(true);
    lowerCase !== '' && debouncedFetchSearchResults(lowerCase);
  };

  // Handle key up event
  const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      setRenderSearchResults(true);
    }
  };

  return (
    <>
      {showProjectDetails ? (
        <ProjectInfoMain />
      ) : (
        <Box
          padding={['24px 24px', '24px 24px', '36px 14px 100px 14px']}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="space-between"
          height="100%"
        >
          <Box width={['100%', '100%', 'unset']}>
            <InputGroup>
              <InputLeftElement pointerEvents="none" h="50px">
                <SearchIcon />
              </InputLeftElement>
              <Input
                onChange={inputHandler}
                onKeyUp={handleKeyUp}
                placeholder="Search for Crypto Projects"
                borderRadius="18px"
                background="#fff"
                size="lg"
                height="50px"
                width={['-webkit-fill-available', '-webkit-fill-available', '620px', '620px', '879px']}
                border="1px solid rgba(0, 0, 0, 0.10)"
              />
            </InputGroup>
            <Box display="flex" justifyContent="center">
              {inputText !== '' && <List input={inputText} />}
            </Box>
          </Box>
          {inputText === '' && !renderSearchResults && (
            <>
              <Box>
                <Box display="flex" justifyContent="center" gap="16px">
                  <CoveySymbol />
                </Box>
                <Text
                  textAlign={['center', 'center']}
                  color="#000"
                  fontSize="32px"
                  fontStyle="normal"
                  fontWeight="600"
                  lineHeight="normal"
                >
                  Search for innovative crypto projects now.
                </Text>
              </Box>
              <Box>
                <Text
                  color="rgba(0, 0, 0, 0.50)"
                  fontSize="12px"
                  fontStyle="normal"
                  fontWeight="500"
                  lineHeight="normal"
                >
                  © 2026 Covey, all rights reserved
                </Text>
              </Box>
            </>
          )}
          <Box display={['block', 'block', 'none']} marginTop="20px" width="94%" margin="0 auto">
            <MobileMenu />
          </Box>
        </Box>
      )}
    </>
  );
}
